import { Router } from "@lit-labs/router"
import { css, html, LitElement } from "lit"
import "../pages/PageAccueil.js"
import "../pages/PageFAQ.js"
import "../pages/PageEchangesPokemons.js"
import "../pages/PageEchanges.js"
import "../pages/PageMaRecherche.js"
import "../pages/PageRecherche.js"
import "../pages/PageCommunaute.js"
import "../pages/PageNews.js"
import "../pages/PageRessourcesUtile.js"
import "../pages/PageCommentCaMarche.js"
import "../pages/PageSommaireBlog.js"
import "../pages/PageBlog.js"
import "../pages/PageListeMessages.js"
import "../pages/PageMessage.js"
import "../pages/PageContact.js"
import "../pages/PageAPropos.js"
import "../composants/MenuHamburger.js"
import "../composants/MenuBasPage.js"
import PopupBase from "@luminecence/composants/PopupBase"
import { naviguerVers } from "./Utilitaire.js"
import "@luminecence/composants/PopupInformation"

export default class Routeur extends LitElement {
  static TITRE_SITE = "Echanges pokémon"

  static styles = css`
    main {
      padding-bottom: calc(var(--hauteur-menu-bas) + env(safe-area-inset-bottom));
      box-sizing: border-box;
    }

    main[data-focus-route="true"]:focus {
      outline: 2px solid color-mix(in srgb, var(--couleur-600) 55%, transparent);
      outline-offset: 4px;
      border-radius: 8px;
    }
  `

  #supprimerStyleFocusRoute = () => {
    const main = this.renderRoot?.querySelector("main")
    if (!(main instanceof HTMLElement)) {
      return
    }

    main.removeAttribute("data-focus-route")
    main.removeAttribute("tabindex")

    if (this.renderRoot instanceof ShadowRoot && this.renderRoot.activeElement === main) {
      main.blur()
    }
  }

  #focaliserContenuPrincipal = () => {
    this.updateComplete.then(() => {
      requestAnimationFrame(() => {
        const main = this.renderRoot?.querySelector("main")
        if (!(main instanceof HTMLElement)) {
          return
        }

        main.setAttribute("tabindex", "-1")
        main.setAttribute("data-focus-route", "true")
        main.focus({ preventScroll: true })
      })
    })
  }

  #_routeur = new Router(this, [
    { path: "/", render: () => html`<p-page-accueil></p-page-accueil>`, enter: () => this.#entrerPagePublique("Accueil") },
    { path: "/faq", render: () => html`<p-page-faq></p-page-faq>`, enter: () => this.#entrerPagePublique("FAQ") },
    { path: "/contact", render: () => html`<p-page-contact></p-page-contact>`, enter: () => this.#entrerPagePublique("Contact") },
    { path: "/a-propos", render: () => html`<p-page-a-propos></p-page-a-propos>`, enter: () => this.#entrerPagePublique("À propos") },
    { path: "/blog", render: () => html`<p-page-sommaire-blog></p-page-sommaire-blog>`, enter: () => this.#entrerPagePublique("Blog") },
    {
      path: "/blog/:nomFichier",
      render: (params) => html`<p-page-blog .nomFichier=${params.nomFichier}></p-page-blog>`,
      enter: () => this.#entrerPagePublique("Blog"),
    },
    {
      path: "/blog/:nomFichier/",
      render: (params) => html`<p-page-blog .nomFichier=${params.nomFichier}></p-page-blog>`,
      enter: () => this.#entrerPagePublique("Blog"),
    },
    {
      path: "/comment-ca-marche",
      render: () => html`<p-page-comment-ca-marche></p-page-comment-ca-marche>`,
      enter: () => this.#entrerPagePublique("Comment ça marche"),
    },
    { path: "/news", render: () => html`<p-page-news></p-page-news>`, enter: () => this.#entrerPagePublique("News") },
    {
      path: "/ressources-utiles",
      render: () => html`<p-page-ressources-utile></p-page-ressources-utile>`,
      enter: () => this.#entrerPagePublique("Ressources utiles"),
    },
    {
      path: "/conversations",
      render: () => html`<p-page-liste-messages></p-page-liste-messages>`,
      enter: async () => await this.#entrerPagePrivee("Conversations"),
    },
    {
      path: "/conversations/:id",
      render: (params) => html`<p-page-message .idConversation=${params.id}></p-page-message>`,
      enter: () => this.#entrerPagePrivee("Conversation"),
    },
    { path: "/communaute", render: () => html`<p-page-communaute></p-page-communaute>`, enter: () => this.#entrerPagePrivee("Communauté") },
    {
      path: "/communaute/:id",
      render: (params) => html`<h1>Détails de la communauté ${params.id}</h1>`,
      enter: () => this.#entrerPagePublique("Détail communauté"),
    },
    {
      path: "/communaute/:id/echanges",
      render: (params) => html`<p-page-echanges .idCommunaute=${params.id}></p-page-echanges>`,
      enter: () => this.#entrerPagePrivee("Échanges communauté"),
    },
    { path: "/recherche", render: () => html`<p-page-recherche></p-page-recherche>`, enter: () => this.#entrerPagePrivee("Recherche") },
  ])

  #mettreAJourTitreDocument = (titrePage) => {
    document.title = titrePage ? `${titrePage} - ${Routeur.TITRE_SITE}` : Routeur.TITRE_SITE
  }

  #entrerPagePublique = (titrePage) => {
    this.#mettreAJourTitreDocument(titrePage)
    this.#focaliserContenuPrincipal()
    return true
  }

  #entrerPagePrivee = async (titrePage) => {
    if (!(await this.gererRoutingAvecAuthentification())) {
      return false
    }

    this.#mettreAJourTitreDocument(titrePage)
    this.#focaliserContenuPrincipal()
    return true
  }

  #gererNavigation = (event) => {
    naviguerVers(event.detail.path)
  }

  #gererErreurGlobale = (event) => {
    const erreur = event.error || event.message
    console.error("Erreur captée :", event.error?.message || event.message)
    window.authentification?.bdd?.clientLogs?.logErrorToFirebase(erreur, "Erreur globale non capturée", window.authentification?.getUser()?.displayName)
  }

  connectedCallback() {
    super.connectedCallback()
    this.addEventListener("navigate", this.#gererNavigation)
    this.addEventListener("deconnexion", this.deconnecter)
    window.addEventListener("keydown", this.#supprimerStyleFocusRoute, true)
    window.addEventListener("pointerdown", this.#supprimerStyleFocusRoute, true)
    window.addEventListener("error", this.#gererErreurGlobale)
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    this.removeEventListener("navigate", this.#gererNavigation)
    this.removeEventListener("deconnexion", this.deconnecter)
    window.removeEventListener("keydown", this.#supprimerStyleFocusRoute, true)
    window.removeEventListener("pointerdown", this.#supprimerStyleFocusRoute, true)
    window.removeEventListener("error", this.#gererErreurGlobale)
  }

  firstUpdated() {
    window.prerenderReady = true
  }

  render() {
    return html`
      <p-menu-hamburger></p-menu-hamburger>
      <main>${this.#_routeur.outlet()}</main>
      <p-menu-bas-page></p-menu-bas-page>
    `
  }

  async gererRoutingAvecAuthentification() {
    if (!this.estConnecter()) {
      await PopupBase.ouvrirEtAttendre("p-popup-information", {
        titre: "Accès restreint",
        texte: "Vous devez être connecté pour accéder à cette page.",
      })
      naviguerVers("/")
      return false
    }
    return true
  }

  estConnecter() {
    return window.authentification.getUser() !== null
  }

  deconnecter() {
    naviguerVers("/")
  }
}
customElements.define("p-routeur", Routeur)
